export const exportSignatureAsSvgBlob = async (canvasRef) => {
    const exportSvg = canvasRef.current?.exportSvg;

    if (!exportSvg) {
        throw new Error('Canvas not rendered yet');
    }

    const svg = await exportSvg();
    const normalizedSvg = svg.includes('xmlns=')
        ? svg
        : svg.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');

    return new Blob([normalizedSvg], {type: 'image/svg+xml'});
};
